var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7261 28.4128C29.9005 28.5871 29.9985 28.8236 29.9985 29.0702C29.9985 29.3168 29.9005 29.5533 29.7261 29.7277C29.5517 29.902 29.3152 30 29.0686 30C28.822 30 28.5855 29.902 28.4111 29.7277L23.5 24.8153L18.5873 29.7261C18.413 29.9005 18.1765 29.9985 17.9298 29.9985C17.6832 29.9985 17.4467 29.9005 17.2723 29.7261C17.098 29.5518 17 29.3153 17 29.0687C17 28.8221 17.098 28.5856 17.2723 28.4112L22.185 23.5004L17.2739 18.588C17.0995 18.4136 17.0015 18.1772 17.0015 17.9306C17.0015 17.684 17.0995 17.4475 17.2739 17.2731C17.4483 17.0987 17.6848 17.0008 17.9314 17.0008C18.178 17.0008 18.4145 17.0987 18.5889 17.2731L23.5 22.1855L28.4127 17.2723C28.587 17.098 28.8236 17 29.0702 17C29.3168 17 29.5533 17.098 29.7277 17.2723C29.902 17.4467 30 17.6832 30 17.9298C30 18.1764 29.902 18.4129 29.7277 18.5872L24.815 23.5004L29.7261 28.4128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e6b1e9e8d5487dddda3adbe978ba0233.svg";
export { ForwardRef as ReactComponent };